import React, { useState } from "react";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import { useEditAssignmentMutation } from "../../../features/assignment/assignmentApi";

export default function EditAssignment({ assignment }) {
  const {
    id,
    title: initialTitle,
    video_id: initialVideoId,
    video_title: initialvideoTitle,
    totalMark: initialMark,
  } = assignment;

  const [title, setTitle] = useState(initialTitle);
  const [mark, setMark] = useState(initialMark);
  const [videoId, setVideoId] = useState(initialVideoId);
  const [videoTitle, setVideoTitle] = useState(initialvideoTitle);

  const [
    editAssignment,
    {
      isLoading: editAssignmentLoading,
      isSuccess: editAssignmentSuccess,
      isError: editAssignmentError,
    },
  ] = useEditAssignmentMutation();

  const handleSubmit = (e) => {
    e.preventDefault();
    editAssignment({
      id,
      data: {
        title,
        video_id: videoId,
        video_title: videoTitle,
        totalMark: Number(mark),
      },
    });
  };

  const optionsSelect = (e) => {
    setVideoId(e.target.value);
    setVideoTitle(e.target.selectedOptions[0].childNodes[0].data);
  };

  let option = null;
  const { data, isLoading, isError } = useGetVideosQuery();
  if (!isLoading && data)
    option = data.map((video, i) => (
      <option key={i} value={video.id}>
        {video.title}
      </option>
    ));

  return (
    <form className="video-form" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <label>Select Video</label>
        <select
          name="video"
          className="text-input"
          value={videoId}
          onChange={optionsSelect}
        >
          <option hidden>Choose Video</option>
          {option}
        </select>
      </div>
      <div className="space-y-2">
        <label>Assignment Title</label>
        <input
          required
          className="text-input"
          type="text"
          name="title"
          value={title}
          placeholder="Enter Assignment Title"
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <label>Total Mark</label>
        <input
          required
          className="text-input"
          type="number"
          min="0"
          max="100"
          name="url"
          placeholder="Enter Full Mark"
          value={mark}
          onChange={(e) => setMark(e.target.value)}
        />
      </div>

      <button
        disabled={editAssignmentLoading}
        type="submit"
        className="submit"
        id="lws-submit"
      >
        Add Video
      </button>
      <div>
        {editAssignmentSuccess && (
          <p className="text-center" style={{ color: "green" }}>
            Assignment update successfully
          </p>
        )}
        {editAssignmentError && (
          <p className="text-center" style={{ color: "red" }}>
            There was an error
          </p>
        )}
      </div>
    </form>
  );
}
